
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DeviceProfileForm } from './device-form';

interface RegisterDeviceCardProps {
  onComplete: () => void;
}

const RegisterDeviceCard: React.FC<RegisterDeviceCardProps> = ({ onComplete }) => {
  return (
    <Card className="border-none shadow-none">
      <CardHeader className="px-0">
        <CardTitle>Register New Device</CardTitle>
        <CardDescription>
          Add a new IoT device to your monitoring system. Complete all required fields marked with *.
        </CardDescription>
      </CardHeader>
      <CardContent className="px-0">
        <DeviceProfileForm onComplete={onComplete} />
      </CardContent>
    </Card>
  );
};

export default RegisterDeviceCard;
